import styled from "@mui/material/styles/styled";

import Stack from "@rui/Stack";

export const SettingWrapper = styled(Stack)(({ theme }) => ({
  gap: theme.spaces.small,
  [theme.breakpoints.down("mobile")]: {
    "& .integration-setting--dropdown": {
      marginLeft: "52px",
    },
  },
  [theme.breakpoints.up("mobile")]: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    gap: theme.spaces.base,
  },
}));
